export default "__VITE_ASSET__7de033f2__"